import React from 'react';
import PropTypes from 'prop-types';
import AuthorDateTimeComments from 'src/components/AuthorDateTimeComments';

function DeniedReason({ claim }) {
  const comments = claim.denials.map((claimDenial) => {
    const { denialReason, dateCreated, ...rest } = claimDenial;
    return {
      ...rest,
      commentType: denialReason,
      //message: denialNote ?? 'Claim denial reversed',
      createdDate: dateCreated
    };
  });
  return (
    <AuthorDateTimeComments comments={comments} />
  );
}

DeniedReason.propTypes = {
  claim: PropTypes.object.isRequired
};

DeniedReason.defaultProps = {};

export default DeniedReason;
